function NXHandShake({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M0.548065 3.08479L2.74248 4.26577L4.70124 3.92663C5.36246 3.81215 6.04008 4.00143 6.54626 4.442"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2822 9.28247L8.17962 11.4859C7.49762 11.9703 6.58622 11.979 5.89504 11.5078L0.548065 7.86287"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4023 7.83946L11.207 9.33957L7.80082 6.58926L6.54792 7.50114C6.03847 7.87193 5.32678 7.77203 4.9391 7.27531C4.55231 6.77973 4.62693 6.06695 5.10797 5.66221L6.41255 4.56456C7.03782 4.03847 7.85064 3.7902 8.66315 3.87714L10.6964 4.09468L13.4023 2.63207"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.80127 6.59656C8.62088 7.32678 9.78322 6.95425 10.2154 6.35815"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXHandShake;
